import { Navigate } from 'react-router-dom';
import { useGetUserByIdQuery } from './store/api/user.api'
import { useSelector } from 'react-redux';

export const AdminRoute = ({ children }) => {

	const tgId = useSelector(state => state.user.user?.id);

	const { data } = useGetUserByIdQuery(tgId);

	if (!data) {
		return <Navigate to="/" replace />;
	}

	if (data?.role !== 'ADMIN') {
		return <Navigate to="/" replace />;
	}

	return children;
};
